const defaultProps = {
  accessibility: true,
  autoplay: false,
  autoplaySpeed: 3000,
  className: '',
  cssEase: 'ease',
  easing: 'linear',
  edgeFriction: 0.35,
  infinite: true,
  initialSlide: 0,
  rows: 1,
  rtl: false,
  slide: 'div',
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  touchThreshold: 5,
  vertical: false,
}

export default defaultProps
